export const ORGAN_DONATION_WITH_ACTE_REMUNERATION_PREFIX = '257';
export const ORGAN_DONATION_WITH_MIXTE_REMUNERATION_PREFIX = '258';

export const ORGAN_DONATION_LUMPSUM_CODES = ['xxx265', 'xxx266', 'xxx267', 'xxx268', 'xxx269'];

export const isOrganDonationCode = (code) => ORGAN_DONATION_LUMPSUM_CODES.includes(code);
